const NotOnlineBanner = () => {
  return (
    <div className="fixed top-0 z-20 w-full flex items-center justify-center gap-x-6 bg-red-500 px-6 sm:px-3.5">
      <p className="text-sm leading-6 text-white">
        Your internet connection is currently offline. You may experience some disruptions in the
        service.
      </p>
    </div>
  )
}

export default NotOnlineBanner
